import $ from "jquery";
import User from './../libs/User.js';

const EN_KO = window.EN_KO;

class FactfinderTracking {
	#user = {
		id: null,
		loggedIn: false,
	};

	constructor( user ) {
		this.#user = user;

		this.login();
		this.productClick();
		this.cart();
		this.checkout();
	}


	getCampaigns() {
		try {
			return JSON.parse( window.sessionStorage.getItem( 'factfinder_campaign_list' ) || '{}' );
		} catch( err ) {
			console.error( err ); // eslint-disable-line no-console
			return {};
		}
	}

	addCampaign( masterId, campaign = null ) {

		const list = this.getCampaigns();
		if ( campaign ) {
			list[ masterId ] = campaign;
			window.sessionStorage.setItem( 'factfinder_campaign_list', JSON.stringify( list ) );
		} else if ( masterId in list ) {
			delete list[ masterId ];
			window.sessionStorage.setItem( 'factfinder_campaign_list', JSON.stringify( list ) );
		}

		return this.getCampaign( masterId );
	}

	getCampaign( masterId ) {
		const list = this.getCampaigns();
		return list[ masterId ] ?? '';
	}

	login() {
		if ( 'localStorage' in window ) {
			const isLoggedIn = this.#user.loggedIn;
			const wasLoggedIn = localStorage.getItem( 'ff_was_logged_in' ) || false;

			if ( isLoggedIn && ! wasLoggedIn ) {
				this.track( 'login' );
			}

			localStorage.setItem( 'ff_was_logged_in', isLoggedIn );
		}
	}

	productClick() {
		const afterSearchEls = document.querySelectorAll( '.mdl_factfinder_aftersearch' );
		afterSearchEls.forEach( afterSearchEl => afterSearchEl.addEventListener( 'click', ( ev ) => {
			if ( ev.isDefaultPrevented ) {
				return;
			}

			if ( ! ev.target.closest( '.en_mdl_product a[href]' ) ) {
				return;
			}

			if ( ev.target.closest( '.en_mdl_product__wishlist-button' ) ) {
				return;
			}

			const AfterSearch = afterSearchEl.ACL_FACTFINDER_AFTERSEARCH;
			const productEl = ev.target.closest( '.en_mdl_product' );
			if ( productEl ) {
				const { paging, searchParams } = AfterSearch.lastResponse;
				const masterId = productEl.getAttribute( 'data-eec-id' ) ?? '';
				const eventData = {
					campaign: this.addCampaign( masterId, productEl.getAttribute( 'data-ff-campaign' ) ?? null ),
					id: productEl.getAttribute( 'data-dy-sku' ) ?? '',
					masterId,
					page: paging.currentPage ?? 0,
					pageSize: paging.pageCount ?? 0,
					pos: Array.from( productEl.parentNode.children ).indexOf( productEl ) + 1,
					purchaserId: '',
					query: searchParams.query ?? '',
					score: productEl.getAttribute( 'data-ff-score' ) ?? 0,
					title: productEl.getAttribute( 'data-eec-name' ) ?? '',
				};

				this.track( 'click', eventData );
			}
		} ) );
	}

	cart() {
		document.addEventListener( 'added_to_cart.acl', ( ev ) => {
			const { params } = ev.detail;

			const holder = document.querySelector( '#popup_article .article_submit_wrapper' ) || document.querySelector( '.article_submit_wrapper' );

			const masterId = params.marketartikelid ?? '';
			const eventData = {
				campaign: this.getCampaign( masterId ),
				count: params.am ?? 1,
				id: params.anid ?? '',
				masterId,
				price: holder.getAttribute( 'data-eec-price' ) ?? '',
				purchaserId: '',
				title: holder.getAttribute( 'data-eec-name' ) ?? '',
			};

			this.track( 'cart', eventData )

		} );

		document.addEventListener( 'changed_cart_amount.acl', ( ev ) => {
			const product = ev.target.closest( '.mdl_article_item' );
			const selectEl = ev.target.closest( '.amount_selector' );
			if ( product && selectEl ) {
				const optionEl = selectEl.options[ selectEl.selectedIndex ] ?? null;

				if ( optionEl ) {
					const masterId = product.getAttribute( 'data-id' ) ?? '';
					const eventData = {
						campaign: this.getCampaign( masterId ),
						count: optionEl.text ?? 1,
						id: product.getAttribute( 'data-sku' ) ?? '',
						masterId,
						price: product.getAttribute( 'data-price' ) ?? '',
						purchaserId: '',
						title: product.getAttribute( 'data-name' ) ?? '',
					};

					this.track( 'cart', eventData )
				}
			}
		} )
	}

	checkout() {

		document.addEventListener( 'checkout_thankyou.acl', ( ev ) => {
			const {products} = ev.detail;
			const eventData = products.map( product => {
				const masterId = product.id;
				return {
					'campaign': this.getCampaign( masterId ),
					'count': product.quantity,
					'id': product.dimension10,
					'masterId': masterId,
					'price': product.price,
					'purchaserId': '',
					'title': product.name,
				}
			} );

			this.track( 'checkout', eventData );
		} )
	}

	track( type, events = {} ) {
		const formEl = document.querySelector( '.mdl_search__form[data-channel]' );
		const channel = formEl?.dataset?.channel || window.FFChannel;

		let factfinderUrl = `/fact-finder/track/${channel}/${type}/`;
		let headers = {};
		if ( document.location.host.endsWith( '.local' ) && localStorage.getItem( 'ff-custom-login-data' ) ) {
			factfinderUrl = `https://kastner-oehler.fact-finder.at/fact-finder/rest/v5/track/${channel}/${type}/`;
			headers = {
				// You can set the header with:
				// localStorage.setItem( 'ff-custom-login-data', 'Basic ' + btoa( loginDataString ) )
				'Authorization': localStorage.getItem( 'ff-custom-login-data' ),
			};
		}

		// Add userid
		const params = [].concat( events ).map( event => {
			return {
				...event,
				userId: this.#user.id,
				sid: EN_KO.functions.getFactfinderSession()
			};
		} )

		return fetch( factfinderUrl, {
			method: 'POST',
			body: JSON.stringify( params ),
			headers: {
				"Content-Type": "application/json",
				...headers
			},
			keepalive: true,
		} )
			.then( res => res.ok )
			.catch( err => {
				console.error( err ); // eslint-disable-line no-console
				return false;
			} );
	}
}

const initFactfinderTracking = () => {
	User.getData().then( ( { data } ) => {
		new FactfinderTracking( data.user );
	} );
}

$( document ).ready( function() {
	initFactfinderTracking();
} )

export {
	FactfinderTracking as default,
	initFactfinderTracking
};
